import { Card, CardBody, Grid, Spinner } from '@chakra-ui/react';
import { startCase } from 'lodash';

import { type OptimizationMeta } from '@/cip/_openapi/portfolio-optimizer';

import { CollapsibleList } from '../../widgets/CollapsibleList';
import { DateCell } from '../../widgets/Table/DateCell';
import { TextCell } from '../../widgets/Table/TextCell';

export const OptimizationSummary = ({
    optimizationMeta,
    isLoading,
}: {
    optimizationMeta?: OptimizationMeta;
    isLoading?: boolean;
}) => {
    return (
        <Card>
            <CardBody>
                {isLoading ? (
                    <Spinner size="xl" />
                ) : (
                    <Grid templateColumns="max-content 1fr" rowGap={1} columnGap={10}>
                        <TextCell value="Details" />
                        <TextCell value={optimizationMeta?.optimizationRequest?.details} />

                        <TextCell value="Data as of date" />
                        <DateCell dateString={optimizationMeta?.optimizationRequest?.dataAsOfDate} />

                        <TextCell value="Action" />
                        <TextCell value={startCase(optimizationMeta?.optimizationRequest?.algoAction)} />

                        <TextCell value="Allocation types" />
                        <CollapsibleList
                            items={optimizationMeta?.optimizationRequest?.allocationTypes ?? []}
                            initialCount={5}
                        />

                        <TextCell value="Portfolios" />
                        <CollapsibleList
                            items={optimizationMeta?.optimizationRequest?.accountGuids ?? []}
                            initialCount={10}
                        />
                    </Grid>
                )}
            </CardBody>
        </Card>
    );
};
